export default {
    "praemien": {
        "version": "debug2026",
        // Verkehrs-RS nach Anzahl Fahrzeuge
        "VERK": {
            "ARB": "§21",
            // Flotte A
            "GWVERKA": {
                "RANGE": [{
                        "@RMIN": "1",
                        "@ALIAS": "1-2",
                        "@RMAX": "2",
                        "SB150": "122,56", "SB300": "104,30", "SB500": "86,05", "SB1000": "77,45"
                    }, {
                        "@RMIN": "3",
                        "@ALIAS": "3-4",
                        "@RMAX": "4",
                        "SB150": "239,88", "SB300": "203,37", "SB500": "168,18", "SB1000": "151,36"
                    }, {
                        "@RMIN": "5",
                        "@ALIAS": "5-6",
                        "@RMAX": "6",
                        "SB150": "402,97", "SB300": "328,53", "SB500": "258,96", "SB1000": "233,07"
                    }, {
                        "@RMIN": "7",
                        "@ALIAS": "7-8",
                        "@RMAX": "8",
                        "SB150": "530,37", "SB300": "432,36", "SB500": "342,11", "SB1000": "307,89"
                    }, {
                        "@RMIN": "9",
                        "@ALIAS": "9-10",
                        "@RMAX": "10",
                        "SB150": "659,26", "SB300": "537,60", "SB500": "425,25", "SB1000": "382,73"
                    }
                ],
                "plus2": {
                    "SB150": "80,00",
                    "SB300": "68,00",
                    "SB500": "56,00"
                }
            },
            // Flotte B
            "GWVERKB": {
                "RANGE": [{
                        "@RMIN": "1",
                        "@ALIAS": "1,2",
                        "@RMAX": "2",
                        "SB150": "221,63", "SB300": "189,03", "SB500": "155,15", "SB1000": "139,63"

                    }, {
                        "@RMIN": "3",
                        "@ALIAS": "4,3",
                        "@RMAX": "4",
                        "SB150": "500,75", "SB300": "425,19", "SB500": "351,11", "SB1000": "316,00"
                    }, {
                        "@RMIN": "5",
                        "@ALIAS": "5,6",
                        "@RMAX": "6",
                        "SB150": "758,05", "SB300": "644,04", "SB500": "530,02", "SB1000": "477,02"

                    }, {
                        "@RMIN": "7",
                        "@ALIAS": "7,8",
                        "@RMAX": "8",
                        "SB150": "1.001,90", "SB300": "851,14", "SB500": "701,97", "SB1000": "631,76"

                    }, {
                        "@RMIN": "9",
                        "@ALIAS": "9,10",
                        "@RMAX": "10",
                        "SB150": "1.260,81", "SB300": "1.072,01", "SB500": "883,20", "SB1000": "794,88"

                    }
                ],
                "plus2": {
                    "SB150": "150,00",
                    "SB300": "128,00",
                    "SB500": "105,00"
                }
            },
            // Flotte C
            "GWVERKC": {
                "RANGE": {
                    "@multi": "1",
                    "SB150": "20,86", "SB300": "16,95", "SB500": "14,34", "SB1000": "12,92"

                }
            }
        },
        // Firmen-RS nach Anzahl Mitarbeiter
        "FIRM": {
            "@TXT": "Firmen-Rechtsschutz",
            "ARB": "§24",
            "RANGE": [{
                "@RMIN": 0,
                "@RMAX": 0,
                "SB150": "98,66",
                "SB300": "84,20",
                "SB500": "69,72",
                "SB1000": "59,26"
              },
              {
                "@RMIN": 1,
                "@RMAX": 3,
                "SB150": "143,39",
                "SB300": "122,35",
                "SB500": "99,98",
                "SB1000": "84,99"
              },
              {
                "@RMIN": 4,
                "@RMAX": 6,
                "SB150": "272,12",
                "SB300": "230,98",
                "SB500": "191,15",
                "SB1000": "162,48"
              },
              {
                "@RMIN": 7,
                "@RMAX": 10,
                "SB150": "401,78",
                "SB300": "341,51",
                "SB500": "281,25",
                "SB1000": "239,06"
              },
              {
                "@RMIN": 11,
                "@RMAX": 15,
                "SB150": "547,98",
                "SB300": "465,78",
                "SB500": "383,60",
                "SB1000": "326,06"
              },
              {
                "@RMIN": 16,
                "@RMAX": 20,
                "SB150": "713,18",
                "SB300": "606,99",
                "SB500": "499,22",
                "SB1000": "424,34"
              },
              {
                "@RMIN": 21,
                "@RMAX": 25,
                "SB150": "887,51",
                "SB300": "754,38",
                "SB500": "621,26",
                "SB1000": "528,08"
              },
              {
                "@RMIN": 26,
                "@RMAX": 30,
                "SB150": "1.025,33",
                "SB300": "871,53",
                "SB500": "717,73",
                "SB1000": "610,08"
              },
              {
                "@RMIN": 31,
                "@RMAX": 40,
                "SB150": "1.323,00",
                "SB300": "1.124,55",
                "SB500": "926,10",
                "SB1000": "787,20"
              },
              {
                "@RMIN": 41,
                "@RMAX": 50,
                "SB150": "1.598,63",
                "SB300": "1.358,84",
                "SB500": "1.119,04",
                "SB1000": "951,20"
              }
            ]
        },
        // Immobilie
        "MIET": {
            "@TXT": "Immobilien-Rechtsschutz",
            "ARB": "§29",
            "SELBST": {
                // nach Fläche in Quadratmeter SELBST Deckungsart=G0003 Objektart=SIM
                "@TXT": "für vom Eigentümer selbst genutzte gewerbliche Objekte",
                "RANGE": [{
                        "@RMIN": "0",
                        "@RMAX": "250",
                        "SB150": "84,44", "SB300": "69,64", "SB500": "57,78", "SB1000": "52,01"
                    }, {
                        "@RMIN": "251",
                        "@RMAX": "500",
                        "SB150": "159,05", "SB300": "132,98", "SB500": "108,21", "SB1000": "97,40"
                    }
                ],
                "PLUS": {
                    "@RMIN": "500",
                    "@UNIT": "250",
                    "SB150": "72,59", "SB300": "60,73", "SB500": "50,37", "SB1000": "45,34"
                    //Plus nicht in den PIA Listen sondern PDFs
                }
            },
            "MIET": {
                // nach Jahresbruttomiete in Euro Deckungsart=G0003 Objektart=GIM Mindestprämie ist netto in Ecxel
                // Bemessungs GL Detail=01 ist Mieter =02 Vermieter
                "@TXT": "für Mieter gewerblicher Objekte",
                "SB150": "8,55", "SB300": "7,17", "SB500": "5,93", "SB1000": "5,33",
                "MIN150": "209,90", "MIN300": "175,82", "MIN500": "143,12", "MIN1000": "128,80"
            },
            "VERMIET": {
                // nach Jahresbruttomiete in Euro
                "@TXT": "für Verrmieter gewerblicher Objekte",
                "SB150": "9,10", "SB300": "7,57", "SB500": "6,20", "SB1000": "5,58",
                "MIN150": "226,25", "MIN300": "188,09", "MIN500": "154,02", "MIN1000": "138,62"
            },
            "GARAGE": {
                // nach Anzahl Objekte Deckungsart=G0003 Objektart=GAR
                "@UNIT": "1",
                "@TXT": "für Garagen und Abstellplätze",
                "SB150": "41,24", "SB300": "33,43", "SB500": "27,27", "SB1000": "24,54"
            },
            "UNBEBAUT": {
                // nach Fläche in Quadratmeter Deckungsart=G0003 Objektart=UGR
                "@TXT": "für unbebaute Grunstücke",
                "RANGE": {
                    "@RMIN": "0",
                    "@UNIT": "2500",
                    "@PKWMIN": "0",
                    "@PKWMAX": "3",
                    "SB150": "41,24", "SB300": "33,43", "SB500": "27,27", "SB1000": "24,54"

                }
            }
        },
        // KOMPEX
        "SPEZ": {
            // KOMPEX ohne gew. Immobilien-RS Variante=KOMP2 Deckungsart=G0001
            // nach Anzahl Mitarbeiter
            "PBV": [
              {
                "@RMIN": 0,
                "@RMAX": 0,
                "SB150P150": "526,25",
                "SB300P150": "393,14",
                "SB300P300": "336,97",
                "SB500P300": "271,17",
                "SB1000P500": "227,79"
              },
              {
                "@RMIN": 1,
                "@RMAX": 3,
                "SB150P150": "638,08",
                "SB300P150": "485,44",
                "SB300P300": "444,06",
                "SB500P300": "340,20",
                "SB1000P500": "286,61"
              },
              {
                "@RMIN": 4,
                "@RMAX": 6,
                "SB150P150": "840,39",
                "SB300P150": "635,69",
                "SB300P300": "598,87",
                "SB500P300": "449,80",
                "SB1000P500": "380,09"
              },
              {
                "@RMIN": 7,
                "@RMAX": 10,
                "SB150P150": "1163,04",
                "SB300P150": "917,97",
                "SB300P300": "817,82",
                "SB500P300": "641,26",
                "SB1000P500": "543,47"
              },
              {
                "@RMIN": 11,
                "@RMAX": 15,
                "SB150P150": "1564,57",
                "SB300P150": "1241,58",
                "SB300P300": "1172,48",
                "SB500P300": "1034,26",
                "SB1000P500": "879,13"
              },
              {
                "@RMIN": 16,
                "@RMAX": 20,
                "SB150P150": "1885,92",
                "SB300P150": "1492,36",
                "SB300P300": "1392,26",
                "SB500P300": "1192,05",
                "SB1000P500": "1016,23"
              },
              {
                "@RMIN": 21,
                "@RMAX": 25,
                "SB150P150": "2336,07",
                "SB300P150": "1872,51",
                "SB300P300": "1702,84",
                "SB500P300": "1363,50",
                "SB1000P500": "1165,79"
              },
              {
                "@RMIN": 26,
                "@RMAX": 30,
                "SB150P150": "2502,08",
                "SB300P150": "2135,55",
                "SB300P300": "1931,61",
                "SB500P300": "1523,71",
                "SB1000P500": "1306,58"
              },
              {
                "@RMIN": 31,
                "@RMAX": 40,
                "SB150P150": "3173,74",
                "SB300P150": "2594,39",
                "SB300P300": "2400,06",
                "SB500P300": "1868,23",
                "SB1000P500": "1664,58"
              },
              {
                "@RMIN": 41,
                "@RMAX": 50,
                "SB150P150": "3901,48",
                "SB300P150": "3208,28",
                "SB300P300": "3010,84",
                "SB500P300": "2451,45",
                "SB1000P500": "2114,37"
              },
              {
                "@RMIN": 51,
                "@RMAX": 60,
                "SB150P150": "4462,24",
                "SB300P150": "3722,07",
                "SB300P300": "3529,27",
                "SB500P300": "2819,96",
                "SB1000P500": "2490,09"
              },
              {
                "@RMIN": 61,
                "@RMAX": 70,
                "SB150P150": "5040,21",
                "SB300P150": "4155,90",
                "SB300P300": "3941,41",
                "SB500P300": "3151,07",
                "SB1000P500": "2847,46"
              },
              {
                "@RMIN": 71,
                "@RMAX": 80,
                "SB150P150": "5740,88",
                "SB300P150": "4599,97",
                "SB300P300": "4417,99",
                "SB500P300": "3612,21",
                "SB1000P500": "3318,72"
              },
              {
                "@RMIN": 81,
                "@RMAX": 90,
                "SB150P150": "6434,63",
                "SB300P150": "5182,00",
                "SB300P300": "4983,45",
                "SB500P300": "4088,02",
                "SB1000P500": "3766,66"
              },
              {
                "@RMIN": 91,
                "@RMAX": 100,
                "SB150P150": "6919,29",
                "SB300P150": "5707,98",
                "SB300P300": "5495,07",
                "SB500P300": "4519,66",
                "SB1000P500": "4176,30"
              },
              {
                "@RMIN": 101,
                "@RMAX": 110,
                "SB150P150": "7610,90",
                "SB300P150": "6278,80",
                "SB300P300": "6044,50",
                "SB500P300": "4972,00",
                "SB1000P500": "4593,60"
              },
              {
                "@RMIN": 111,
                "@RMAX": 120,
                "SB150P150": "8302,80",
                "SB300P150": "6849,60",
                "SB300P300": "6594,00",
                "SB500P300": "5424,00",
                "SB1000P500": "5011,20"
              },
              {
                "@RMIN": 121,
                "@RMAX": 130,
                "SB150P150": "8994,70",
                "SB300P150": "7420,40",
                "SB300P300": "7143,50",
                "SB500P300": "5876,00",
                "SB1000P500": "5428,80"
              },
              {
                "@RMIN": 131,
                "@RMAX": 140,
                "SB150P150": "9686,60",
                "SB300P150": "7991,20",
                "SB300P300": "7693,00",
                "SB500P300": "6328,00",
                "SB1000P500": "5846,40"
              },
              {
                "@RMIN": 141,
                "@RMAX": 150,
                "SB150P150": "10378,50",
                "SB300P150": "8562,00",
                "SB300P300": "8242,50",
                "SB500P300": "6780,00",
                "SB1000P500": "6264,00"
              }
            ],
            // gew Immobilien-RS für KOMPEX Variante=KOMP1 Deckungsart=G0001
            // Speicherung der Differenz KOMP1 minus KOMP2
            // nach Anzahl Mitarbeiter
            "MIET": [
                  {
                    "@RMIN": 0,
                    "@RMAX": 0,
                    "SB150P150": "70,52",
                    "SB300P150": "57,42",
                    "SB300P300": "50,29",
                    "SB500P300": "41,80",
                    "SB1000P500": "35,12"
                  },
                  {
                    "@RMIN": 1,
                    "@RMAX": 3,
                    "SB150P150": "70,51",
                    "SB300P150": "54,87",
                    "SB300P300": "51,85",
                    "SB500P300": "42,67",
                    "SB1000P500": "35,95"
                  },
                  {
                    "@RMIN": 4,
                    "@RMAX": 6,
                    "SB150P150": "97,80",
                    "SB300P150": "82,29",
                    "SB300P300": "79,76",
                    "SB500P300": "65,06",
                    "SB1000P500": "54,97"
                  },
                  {
                    "@RMIN": 7,
                    "@RMAX": 10,
                    "SB150P150": "104,51",
                    "SB300P150": "94,15",
                    "SB300P300": "87,57",
                    "SB500P300": "77,26",
                    "SB1000P500": "65,48"
                  },
                  {
                    "@RMIN": 11,
                    "@RMAX": 15,
                    "SB150P150": "117,51",
                    "SB300P150": "104,45",
                    "SB300P300": "98,28",
                    "SB500P300": "85,90",
                    "SB1000P500": "73,01"
                  },
                  {
                    "@RMIN": 16,
                    "@RMAX": 20,
                    "SB150P150": "158,80",
                    "SB300P150": "145,55",
                    "SB300P300": "135,39",
                    "SB500P300": "115,06",
                    "SB1000P500": "98,08"
                  },
                  {
                    "@RMIN": 21,
                    "@RMAX": 25,
                    "SB150P150": "196,65",
                    "SB300P150": "183,54",
                    "SB300P300": "174,62",
                    "SB500P300": "156,75",
                    "SB1000P500": "134,01"
                  },
                  {
                    "@RMIN": 26,
                    "@RMAX": 30,
                    "SB150P150": "192,09",
                    "SB300P150": "179,28",
                    "SB300P300": "170,56",
                    "SB500P300": "153,11",
                    "SB1000P500": "131,30"
                  },
                  {
                    "@RMIN": 31,
                    "@RMAX": 40,
                    "SB150P150": "199,23",
                    "SB300P150": "225,80",
                    "SB300P300": "217,93",
                    "SB500P300": "189,39",
                    "SB1000P500": "168,74"
                  },
                  {
                    "@RMIN": 41,
                    "@RMAX": 50,
                    "SB150P150": "208,30",
                    "SB300P150": "240,18",
                    "SB300P300": "232,47",
                    "SB500P300": "204,75",
                    "SB1000P500": "176,59"
                  },
                  {
                    "@RMIN": 51,
                    "@RMAX": 60,
                    "SB150P150": "214,75",
                    "SB300P150": "288,84",
                    "SB300P300": "282,82",
                    "SB500P300": "245,70",
                    "SB1000P500": "216,97"
                  },
                  {
                    "@RMIN": 61,
                    "@RMAX": 70,
                    "SB150P150": "208,08",
                    "SB300P150": "330,56",
                    "SB300P300": "311,47",
                    "SB500P300": "244,52",
                    "SB1000P500": "220,96"
                  },
                  {
                    "@RMIN": 71,
                    "@RMAX": 80,
                    "SB150P150": "213,11",
                    "SB300P150": "386,03",
                    "SB300P300": "366,40",
                    "SB500P300": "290,49",
                    "SB1000P500": "266,90"
                  },
                  {
                    "@RMIN": 81,
                    "@RMAX": 90,
                    "SB150P150": "212,11",
                    "SB300P150": "428,54",
                    "SB300P300": "395,24",
                    "SB500P300": "289,12",
                    "SB1000P500": "266,39"
                  },
                  {
                    "@RMIN": 91,
                    "@RMAX": 100,
                    "SB150P150": "418,18",
                    "SB300P150": "466,16",
                    "SB300P300": "430,68",
                    "SB500P300": "316,68",
                    "SB1000P500": "292,62"
                  },
                  {
                    "@RMIN": 101,
                    "@RMAX": 110,
                    "SB150P150": "459,80",
                    "SB300P150": "512,60",
                    "SB300P300": "474,10",
                    "SB500P300": "347,60",
                    "SB1000P500": "322,30"
                  },
                  {
                    "@RMIN": 111,
                    "@RMAX": 120,
                    "SB150P150": "501,60",
                    "SB300P150": "559,20",
                    "SB300P300": "517,20",
                    "SB500P300": "379,20",
                    "SB1000P500": "351,60"
                  },
                  {
                    "@RMIN": 121,
                    "@RMAX": 130,
                    "SB150P150": "543,40",
                    "SB300P150": "605,80",
                    "SB300P300": "560,30",
                    "SB500P300": "410,80",
                    "SB1000P500": "380,90"
                  },
                  {
                    "@RMIN": 131,
                    "@RMAX": 140,
                    "SB150P150": "585,20",
                    "SB300P150": "652,40",
                    "SB300P300": "603,40",
                    "SB500P300": "442,40",
                    "SB1000P500": "410,20"
                  },
                  {
                    "@RMIN": 141,
                    "@RMAX": 150,
                    "SB150P150": "627,00",
                    "SB300P150": "699,00",
                    "SB300P300": "646,50",
                    "SB500P300": "474,00",
                    "SB1000P500": "439,50"
                  }
            ],
            // KOMPEXplus Ersetzt durch Vertrags-RS Deckungsart=G0008 SB500 für KOMPEX
            // nach Anzahl Mitarbeiter
            "T": [
                  {
                    "@RMIN": 0,
                    "@RMAX": 0,
                    "SB150P150": "989,78",
                    "SB300P150": "989,78",
                    "SB300P300": "989,78",
                    "SB500P300": "989,78",
                    "SB1000P500": "989,78"
                  },
                  {
                    "@RMIN": 1,
                    "@RMAX": 3,
                    "SB150P150": "1048,12",
                    "SB300P150": "1048,12",
                    "SB300P300": "1048,12",
                    "SB500P300": "1048,12",
                    "SB1000P500": "1048,12"
                  },
                  {
                    "@RMIN": 4,
                    "@RMAX": 6,
                    "SB150P150": "1388,18",
                    "SB300P150": "1388,18",
                    "SB300P300": "1388,18",
                    "SB500P300": "1388,18",
                    "SB1000P500": "1388,18"
                  },
                  {
                    "@RMIN": 7,
                    "@RMAX": 10,
                    "SB150P150": "1558,27",
                    "SB300P150": "1558,27",
                    "SB300P300": "1558,27",
                    "SB500P300": "1558,27",
                    "SB1000P500": "1558,27"
                  },
                  {
                    "@RMIN": 11,
                    "@RMAX": 15,
                    "SB150P150": "1988,19",
                    "SB300P150": "1988,19",
                    "SB300P300": "1988,19",
                    "SB500P300": "1988,19",
                    "SB1000P500": "1988,19"
                  },
                  {
                    "@RMIN": 16,
                    "@RMAX": 20,
                    "SB150P150": "2664,65",
                    "SB300P150": "2664,65",
                    "SB300P300": "2664,65",
                    "SB500P300": "2664,65",
                    "SB1000P500": "2664,65"
                  },
                  {
                    "@RMIN": 21,
                    "@RMAX": 25,
                    "SB150P150": "3405,72",
                    "SB300P150": "3405,72",
                    "SB300P300": "3405,72",
                    "SB500P300": "3405,72",
                    "SB1000P500": "3405,72"
                  },
                  {
                    "@RMIN": 26,
                    "@RMAX": 30,
                    "SB150P150": "4245,35",
                    "SB300P150": "4245,35",
                    "SB300P300": "4245,35",
                    "SB500P300": "4245,35",
                    "SB1000P500": "4245,35"
                  },
                  {
                    "@RMIN": 31,
                    "@RMAX": 40,
                    "SB150P150": "5829,50",
                    "SB300P150": "5829,50",
                    "SB300P300": "5829,50",
                    "SB500P300": "5829,50",
                    "SB1000P500": "5829,50"
                  },
                  {
                    "@RMIN": 41,
                    "@RMAX": 50,
                    "SB150P150": "7698,27",
                    "SB300P150": "7698,27",
                    "SB300P300": "7698,27",
                    "SB500P300": "7698,27",
                    "SB1000P500": "7698,27"
                  },
                  {
                    "@RMIN": 51,
                    "@RMAX": 60,
                    "SB150P150": "10387,59",
                    "SB300P150": "10387,59",
                    "SB300P300": "10387,59",
                    "SB500P300": "10387,59",
                    "SB1000P500": "10387,59"
                  },
                  {
                    "@RMIN": 61,
                    "@RMAX": 70,
                    "SB150P150": "13237,83",
                    "SB300P150": "13237,83",
                    "SB300P300": "13237,83",
                    "SB500P300": "13237,83",
                    "SB1000P500": "13237,83"
                  },
                  {
                    "@RMIN": 71,
                    "@RMAX": 80,
                    "SB150P150": "16437,85",
                    "SB300P150": "16437,85",
                    "SB300P300": "16437,85",
                    "SB500P300": "16437,85",
                    "SB1000P500": "16437,85"
                  },
                  {
                    "@RMIN": 81,
                    "@RMAX": 90,
                    "SB150P150": "19976,96",
                    "SB300P150": "19976,96",
                    "SB300P300": "19976,96",
                    "SB500P300": "19976,96",
                    "SB1000P500": "19976,96"
                  },
                  {
                    "@RMIN": 91,
                    "@RMAX": 100,
                    "SB150P150": "23847,79",
                    "SB300P150": "23847,79",
                    "SB300P300": "23847,79",
                    "SB500P300": "23847,79",
                    "SB1000P500": "23847,79"
                  },
                  {
                    "@RMIN": 101,
                    "@RMAX": 110,
                    "SB150P150": "28112,11",
                    "SB300P150": "28112,11",
                    "SB300P300": "28112,11",
                    "SB500P300": "28112,11",
                    "SB1000P500": "28112,11"
                  },
                  {
                    "@RMIN": 111,
                    "@RMAX": 120,
                    "SB150P150": "32595,89",
                    "SB300P150": "32595,89",
                    "SB300P300": "32595,89",
                    "SB500P300": "32595,89",
                    "SB1000P500": "32595,89"
                  },
                  {
                    "@RMIN": 121,
                    "@RMAX": 130,
                    "SB150P150": "37480,53",
                    "SB300P150": "37480,53",
                    "SB300P300": "37480,53",
                    "SB500P300": "37480,53",
                    "SB1000P500": "37480,53"
                  },
                  {
                    "@RMIN": 131,
                    "@RMAX": 140,
                    "SB150P150": "42690,61",
                    "SB300P150": "42690,61",
                    "SB300P300": "42690,61",
                    "SB500P300": "42690,61",
                    "SB1000P500": "42690,61"
                  },
                  {
                    "@RMIN": 141,
                    "@RMAX": 150,
                    "SB150P150": "48227,96",
                    "SB300P150": "48227,96",
                    "SB300P300": "48227,96",
                    "SB500P300": "48227,96",
                    "SB1000P500": "48227,96"
                  }
            ],
            // Spezial-Straf-RS für KOMPEX Deckungsart=G0004 
            // nach Anzahl Mitarbeiter
            "SSRG": [
                 {
                    "@RMIN": 0,
                    "@RMAX": 0,
                    "SB150P150": "110,63",
                    "SB300P150": "110,63",
                    "SB300P300": "106,06",
                    "SB500P300": "106,06",
                    "SB1000P500": "100,77"
                  },
                  {
                    "@RMIN": 1,
                    "@RMAX": 3,
                    "SB150P150": "110,63",
                    "SB300P150": "110,63",
                    "SB300P300": "106,06",
                    "SB500P300": "106,06",
                    "SB1000P500": "100,77"
                  },
                  {
                    "@RMIN": 4,
                    "@RMAX": 6,
                    "SB150P150": "125,55",
                    "SB300P150": "125,55",
                    "SB300P300": "123,73",
                    "SB500P300": "123,73",
                    "SB1000P500": "117,55"
                  },
                  {
                    "@RMIN": 7,
                    "@RMAX": 10,
                    "SB150P150": "136,30",
                    "SB300P150": "136,30",
                    "SB300P300": "131,66",
                    "SB500P300": "131,66",
                    "SB1000P500": "125,08"
                  },
                  {
                    "@RMIN": 11,
                    "@RMAX": 15,
                    "SB150P150": "193,92",
                    "SB300P150": "193,92",
                    "SB300P300": "184,68",
                    "SB500P300": "184,68",
                    "SB1000P500": "175,44"
                  },
                  {
                    "@RMIN": 16,
                    "@RMAX": 20,
                    "SB150P150": "258,56",
                    "SB300P150": "258,56",
                    "SB300P300": "246,25",
                    "SB500P300": "246,25",
                    "SB1000P500": "233,94"
                  },
                  {
                    "@RMIN": 21,
                    "@RMAX": 25,
                    "SB150P150": "339,36",
                    "SB300P150": "339,36",
                    "SB300P300": "323,20",
                    "SB500P300": "323,20",
                    "SB1000P500": "307,04"
                  },
                  {
                    "@RMIN": 26,
                    "@RMAX": 30,
                    "SB150P150": "363,60",
                    "SB300P150": "363,60",
                    "SB300P300": "346,29",
                    "SB500P300": "346,29",
                    "SB1000P500": "328,97"
                  },
                  {
                    "@RMIN": 31,
                    "@RMAX": 40,
                    "SB150P150": "422,40",
                    "SB300P150": "422,40",
                    "SB300P300": "405,94",
                    "SB500P300": "405,94",
                    "SB1000P500": "399,55"
                  },
                  {
                    "@RMIN": 41,
                    "@RMAX": 50,
                    "SB150P150": "477,36",
                    "SB300P150": "477,36",
                    "SB300P300": "466,28",
                    "SB500P300": "466,28",
                    "SB1000P500": "442,97"
                  },
                  {
                    "@RMIN": 51,
                    "@RMAX": 60,
                    "SB150P150": "515,72",
                    "SB300P150": "515,72",
                    "SB300P300": "493,72",
                    "SB500P300": "493,72",
                    "SB1000P500": "478,81"
                  },
                  {
                    "@RMIN": 61,
                    "@RMAX": 70,
                    "SB150P150": "536,89",
                    "SB300P150": "536,89",
                    "SB300P300": "528,59",
                    "SB500P300": "528,59",
                    "SB1000P500": "515,72"
                  },
                  {
                    "@RMIN": 71,
                    "@RMAX": 80,
                    "SB150P150": "556,80",
                    "SB300P150": "556,80",
                    "SB300P300": "542,92",
                    "SB500P300": "542,92",
                    "SB1000P500": "532,00"
                  },
                  {
                    "@RMIN": 81,
                    "@RMAX": 90,
                    "SB150P150": "631,05",
                    "SB300P150": "631,05",
                    "SB300P300": "615,31",
                    "SB500P300": "615,31",
                    "SB1000P500": "602,94"
                  },
                  {
                    "@RMIN": 91,
                    "@RMAX": 100,
                    "SB150P150": "705,29",
                    "SB300P150": "705,29",
                    "SB300P300": "687,70",
                    "SB500P300": "687,70",
                    "SB1000P500": "673,88"
                  },
                  {
                    "@RMIN": 101,
                    "@RMAX": 110,
                    "SB150P150": "775,50",
                    "SB300P150": "775,50",
                    "SB300P300": "756,80",
                    "SB500P300": "756,80",
                    "SB1000P500": "741,40"
                  },
                  {
                    "@RMIN": 111,
                    "@RMAX": 120,
                    "SB150P150": "846,00",
                    "SB300P150": "846,00",
                    "SB300P300": "825,60",
                    "SB500P300": "825,60",
                    "SB1000P500": "808,80"
                  },
                  {
                    "@RMIN": 121,
                    "@RMAX": 130,
                    "SB150P150": "916,50",
                    "SB300P150": "916,50",
                    "SB300P300": "894,40",
                    "SB500P300": "894,40",
                    "SB1000P500": "876,20"
                  },
                  {
                    "@RMIN": 131,
                    "@RMAX": 140,
                    "SB150P150": "987,00",
                    "SB300P150": "987,00",
                    "SB300P300": "963,20",
                    "SB500P300": "963,20",
                    "SB1000P500": "943,60"
                  },
                  {
                    "@RMIN": 141,
                    "@RMAX": 150,
                    "SB150P150": "1057,50",
                    "SB300P150": "1057,50",
                    "SB300P300": "1032,00",
                    "SB500P300": "1032,00",
                    "SB1000P500": "1011,00"
                  }
            ],
            // + 1 weiterer Geschäftsführer für KOMPEX Objektart=GFZ
            "PRIV": {
                "SB150": "304,91",
                "SB300": "236,66",
                "SB500": "195,17"
            },
            // Privat-Spezial-Straf-RS für KOMPEX-Geschäftsführer
            "PRIVSSR": {
                "SB150": "57,36",
                "SB300": "35,02",
                "SB500": "29,77"
            },
            // Zweit-/Ferienwohnung für KOMPEX-Geschäftsführer
            "PRIVZW": {
                "SB150": "57,80",
                "SB300": "45,38",
                "SB500": "36,31"
            },
            // Cyber-RS für KOMPEX-Geschäftsführer
            "PRIVCYBER": {
                "SB150": "77,44"
            },
            // Vermieter-RS für KOMPEX-Geschäftsführer
            // nach Jahresbruttomiete in Euro
            // ab 16001 Euro Beitrag in Prozent
            // ab 24001 Euro nur fuer PKS
            "PRIVVM": [{
                    "@RMIN": "1",
                    "@RMAX": "10000",
                    "SB300": "162,04",
                    "SB500": "137,73"
                }, {
                    "@RMIN": "10001",
                    "@RMAX": "16000",
                    "SB300": "356,87",
                    "SB500": "303,35"
                }, {
                    "@RMIN": "16001",
                    "@RMAX": "24000",
                    "SB300": "2,97",
                    "SB500": "1,93"
                }, {
                    "@RMIN": "24001",
                    "@RMAX": "999999",
                    "SB300": "2,97",
                    "SB500": "1,93"
                }
            ],
            // Leistungserweiterung PRESTIGE für KOMPEX-Geschäftsführer
            "PRIVPRESTIGE": {
                "SB000": "53,05",
                "SB150": "53,05",
                "SB300": "44,74",
                "SB500": "36,77"
            },
            // PKS-Option KOMPEX ohne GF im privaten Bereich
            "PRIVMINUSGF": {
                "SB150": "-80,00",
                "SB300": "-60,00",
                "SB500": "-40,00"
            }
        }
    }
}
;